module.exports = __webpack_public_path__ + "img/BR.36b559ae.png";